import React from 'react';
import styled from 'themes';
import {
  useGetApiContentsPushContent,
} from 'store';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { Viewer } from '@toast-ui/react-editor';
import tableMergedCellPlugin from '@toast-ui/editor-plugin-table-merged-cell';
import { useLocation } from 'react-router';
import queryString from 'query-string';

const PushContent = () => {
  const location = useLocation();

  const query = (
    location.search
      ? queryString.parse(location.search)
      : {
        pushContentId: undefined,
      }
  ) as { pushContentId: string | undefined };

  const queryOption = {
    query: { cacheTime: 0 },
  };

  const { data } =
    useGetApiContentsPushContent(
      {
        pushContentId: query.pushContentId ? +query.pushContentId : undefined,
      },
      queryOption,
    );

  return (
    <Container>
      {data?.result && (
        <Viewer
          initialValue={data.result.pushContentMd}
          plugins={[tableMergedCellPlugin]}
          linkAttributes={{ target: '_blank', rel: 'noopener noreferrer' }}
        />
      )}
    </Container>
  );
};

export default PushContent;

const Container = styled.div`
  padding: 20px 20px 50px 20px;

  /* NOTE: kunhee.lim
   *  table 표 좌측 글자 최소 영역 확보  */
  table tbody tr td:first-child {
    min-width: 90px;
  }
`;
